import { Component, NgModuleRef, OnInit, ViewEncapsulation } from '@angular/core';
import { PaginationService } from 'ngx-pagination';
import { ListBaseComponent } from '../../../shared/components/base/list-base/list-base.component';
import { PaymentActionFilter } from '../../../shared/filters/payment-action.filter';
import { Permissions } from '../../../shared/constants/permissions';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SectionService } from '../../../shared/services/section.service';
import { DocumentIntelligenceService } from '../../../shared/services/document-intelligence.service'
import { Sections } from '../../../shared/constants/sections';
import { Modals } from '../../../shared/constants/modals';
import { DocumentIntelligenceModel } from '../../../shared/models/document-intelligence-model.model';
import { Constants } from '../../../shared/constants/constants';
import { DocumentIntelligenceModelFilter } from '../../../shared/filters/document-intelligence-model.filter';
import { CompanyBase } from '../../../shared/models/company-base.model';

@Component({
  selector: 'app-models-list',
  templateUrl: './models-list.component.html',
  styleUrls: ['./models-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class ModelsListComponent extends ListBaseComponent implements OnInit {
  fieldCollection = [
    { name: 'CompanyName', displayName: 'documentIntelligenceModels.companyNameFieldTitle', canSort: true, displayClass: '' },
    { name: 'DocumentIntelligenceModelId', displayName: 'documentIntelligenceModels.modelIdFieldTitle', canSort: true, displayClass: '' },
    { name: 'Provider', displayName: 'documentIntelligenceModels.providerFieldTitle', canSort: true, displayClass: ''},
    { name: 'ProviderModelId', displayName: 'documentIntelligenceModels.providerModelIdFieldTitle', canSort: true, displayClass: ''},
    { name: 'DefaultFormatConverter', displayName: 'documentIntelligenceModels.defaultFormatConverterFieldTitle', canSort: true, displayClass: ''},
  ];

  documentIntelligenceFilter: DocumentIntelligenceModelFilter;
  modelDeletedSuccessfullyMessage: string;
  
  get companySelectionListClass(): string {
    if (this.hasSelectCompanyPermission) {
      return 'd-none d-xl-block selection-list'
    }

    return '';
  }

  get hasSelectCompanyPermission(): boolean {
    return this.hasPermission(Permissions.DocumentIntelligence_SelectCompany);
  }

  get hasEditModelPermission(): boolean {
    return this.hasPermission(Permissions.DocumentIntelligence_Model_Update);
  }

  get hasViewModelPermission(): boolean {
    return this.hasPermission(Permissions.DocumentIntelligence_Model_View);
  }

  constructor(
    protected sectionService: SectionService,
    protected documentIntelligenceService: DocumentIntelligenceService,
    protected translateService: TranslateService,
    protected modalService: NgbModal,
    protected toastrService: ToastrService) {
      super(sectionService, Sections.DocumentIntelligence, modalService, Modals.DocumentIntelligenceModelComponent);
  }

  ngOnInit(): void {
    this.documentIntelligenceFilter = new DocumentIntelligenceModelFilter();
    super.initializeView(Constants.DocumentIntelligence_Models_DefaultSortField, Constants.DocumentIntelligence_Models_DefaultSortDirectionAscending);
    this.translateService.get(['documentIntelligenceModels.modelDeletedSuccessfullyMessage'])
      .subscribe(translations => {
        this.modelDeletedSuccessfullyMessage = translations['documentIntelligenceModels.modelDeletedSuccessfullyMessage']
      })
  }

  getCollection(pageNumber: number = 1): void {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber
    }
    this.documentIntelligenceService.getCollectionPaginated<DocumentIntelligenceModel>(
      `/document-intelligence/models`,
      this.pageConfiguration,
      this.documentIntelligenceFilter,
      (collection: DocumentIntelligenceModel[]) => { this.collection = collection; }
    )
  }

  handleCompanyChanged(company: CompanyBase): void {
    if (company) {
      this.documentIntelligenceFilter.CompanyId = company.CompanyId;
    }
    else {
      this.documentIntelligenceFilter.CompanyId = undefined;
    }

    this.getCollection(Constants.DefaultPageNumber);
  }

  handleBooleanToggleFilterChanged(): void {
    this.getCollection();
  }

  addDocumentIntelligenceModel(): void {
    const modalReference = this.openModal();
    modalReference.componentInstance.currentObject = null;
    modalReference.componentInstance.isEditMode = false;
    modalReference.componentInstance.afterSubmitEvent.subscribe(() => {
      modalReference.close();
      this.getCollection(this.pageConfiguration.PageNumber);
    });
  }

  editDocumentIntelligenceModel(documentIntelligenceModel): void {
    if (this.hasEditModelPermission) {
      const modalReference = this.openEditModal(documentIntelligenceModel);
      modalReference.componentInstance.isEditMode = true;
      modalReference.componentInstance.afterSubmitEvent.subscribe(() => {
        modalReference.close();
        this.getCollection(this.pageConfiguration.PageNumber);
      });
    }
  }

  deleteDocumentIntelligenceModel(documentIntelligenceModel): void {
    if (this.hasEditModelPermission) {

      this.translateService.get('documentIntelligenceModels.confirmDeleteMessage').subscribe((translatedMessage: string) => {
        const isConfirmed = window.confirm(translatedMessage);
        if (isConfirmed) {
          this.documentIntelligenceService.deleteModel(documentIntelligenceModel.Id, undefined, this.modelDeletedSuccessfullyMessage);
          this.getCollection();
        }
      });
    }
  }
}
